import api from './api'
import type { ApiResponse } from '../types'

// ================================================================================
// SITE VISIT SERVICE — public homepage total-visit (footfall) counter.
// POST /site-visits records a visit and returns the new grand total; GET
// /site-visits/total returns the current total without incrementing. Both are
// public (permitAll). The count starts at 0, so the first recorded visit is 1.
// ================================================================================

/** POST /site-visits — record a homepage load and return the new total. */
export async function recordVisit(): Promise<number> {
  const res = await api.post<ApiResponse<number>>('/site-visits')
  return res.data.data
}

/** GET /site-visits/total — current total without recording a new visit. */
export async function getTotalVisits(): Promise<number> {
  const res = await api.get<ApiResponse<number>>('/site-visits/total')
  return res.data.data
}